/* eslint-disable class-methods-use-this */
import {stringToArray, flattenNestedArrays} from 'Utils/arrayUtils';
import {UAParserService} from 'Services/UAParserService';

// Put data-module="Toggler" on the tag which contains [data-toggle-targets]
// [data-toggle-targets] (string(s with blank between)) list the target(s) which need(s) a className toggler
// [data-toggle-target] (same string as [data-toggle-targets]) element need a className toggler
// [data-toggle-classname] css class to be toggle
// [data-toggle-container] if root container need to be different of element that contains [data-module]
// [data-toggle-parent] (same string as [data-toggle-container]

export default class Toggler {
    constructor(domElement) {
        this.domElement = domElement;
        this.target = domElement.dataset.toggleTargets;
        this.container = null;
        this.targetClassList = [];
        this.targetElementList = [];
        this.flattenElementList = [];

        this.init();
        this.initEvents();
    }

    init() {
        this.container = this.getContainer();
        this.targetClassList = stringToArray(this.target, ' ');
        this.targetElementList = this.getTargetElementList();
        this.flattenElementList = this.getFlattenElementList();
    }

    initEvents() {
        if(UAParserService.getBrowser().name === 'IE') {
            this.domElement.addEventListener('mouseup', this.processToggle.bind(this));
        } else {
            this.domElement.addEventListener('click', this.processToggle.bind(this));
        }
    }

    getContainer() {
        let container = this.domElement;
        if(!this.domElement.hasAttribute('data-toggle-container')) {
            return document;
        }

        while(container) {
            if(!container.dataset || container.dataset.toggleParent === this.domElement.dataset.toggleContainer) {
                return container;
            }

            container = container.parentNode;
        }

        return document;
    }

    getTargetElementList() {
        const targetElementList = this.targetClassList.map(targetClass => [...this.container.querySelectorAll(`[data-toggle-target=${targetClass}]`)]);
        return flattenNestedArrays(targetElementList);
    }

    getPairedElementClassList() {
        return this.targetElementList.map(element => ({
            element,
            classList: stringToArray(element.dataset.toggleClassesname, ' ')
        }));
    }

    getPairedElementClass(pairedElementClassList) {
        return pairedElementClassList.map(pair => pair.classList.map(className => ({
            element: pair.element,
            className
        })));
    }

    getFlattenElementList() {
        const pairedElementClassList = this.getPairedElementClassList();
        const pairedElementClass = this.getPairedElementClass(pairedElementClassList);

        return flattenNestedArrays(pairedElementClass);
    }

    processToggle() {
        this.flattenElementList.forEach(item => {
            item.element.classList.toggle(item.className);
        });
    }
}
